import { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';

export const usePerformanceData = (user, tabValue) => {
  const [performanceOverview, setPerformanceOverview] = useState(null);
  const [loadingPerformanceOverview, setLoadingPerformanceOverview] = useState(false);
  const [performanceError, setPerformanceError] = useState(false);

  // ✅ garante que faz preload 1x quando user.id aparecer
  const didPreloadRef = useRef(false);

  const fetchPerformanceOverview = useCallback(async () => {
    if (!user?.id) return;

    setPerformanceError(false);
    setLoadingPerformanceOverview(true);

    try {
      const response = await api.get(`/performance/overview/${user.id}`);

      // ✅ fetch warning titles (não pode travar o overview)
      let warningTitles = [];
      try {
        const warningsResponse = await api.get(`/employees/${user.id}/warnings/last-titles?limit=5`);
        warningTitles = warningsResponse?.data?.warnings || [];
      } catch (warnErr) {
        console.warn('⚠️ Error fetching warning titles:', warnErr);
        warningTitles = [];
      }

      setPerformanceOverview({
        ...response.data,
        warnings_titles: warningTitles,
      });
    } catch (error) {
      console.error('Error fetching performance overview:', error);
      setPerformanceError(true);
      setPerformanceOverview(null);
    } finally {
      setLoadingPerformanceOverview(false);
    }
  }, [user?.id]);

  // ✅ PRELOAD: carrega assim que abrir a página (assim que user.id existir)
  useEffect(() => {
    if (!user?.id) return;
    if (didPreloadRef.current) return;

    // se quiser respeitar permissão, deixa aqui:
    // if (![1,2,3,4].includes(user?.role_id)) return;

    didPreloadRef.current = true;
    fetchPerformanceOverview();
  }, [user?.id, user?.role_id, fetchPerformanceOverview]);

  // ✅ opcional: quando entrar na tab Performance, se ainda não tem dados, tenta de novo
  useEffect(() => {
    if (!user?.id) return;
    if (tabValue !== 2) return;

    if (!performanceOverview && !loadingPerformanceOverview) {
      fetchPerformanceOverview();
    }
  }, [tabValue, user?.id, performanceOverview, loadingPerformanceOverview, fetchPerformanceOverview]);

  return {
    performanceOverview,
    loadingPerformanceOverview,
    performanceError, // opcional usar no UI
    fetchPerformanceOverview,
  };
};
